import { render, staticRenderFns } from "./LecturaCliente.vue?vue&type=template&id=8101ad26&"
import script from "@/Servicios/LecturaCliente.js?vue&type=script&lang=js&"
export * from "@/Servicios/LecturaCliente.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports